import React from "react";
import styled from "styled-components";
import { Page, PageTitle } from "../components/PageLayout";
import QUERY_ALL_CUSTOMERS from "@sellout/models/.dist/graphql/queries/superAdminAllCustomer.query";
import { useQuery } from "@apollo/react-hooks";
import PageLoader from "../components/PageLoader";
import { PaginationTypes } from "@sellout/models/.dist/interfaces/IPagination";
import PageSearch from "../components/PageSearch";
import { SearchContainer } from "./OrderList.page";
import { media } from "@sellout/ui/build/utils/MediaQuery";
import SuperAdminCustomersList from "../components/SuperAdminCustomersList";

const TableContainer = styled.div`
    display: flex;
    height: 100%;
    ${media.mobile`
      height: calc(100vh - 364px);
  `};
`;
export enum CustomersEnum {
  queryCustomers = "QUERY_ALL_CUSTOMERS",
  searchPlaceHolder = "Search by  Name, Email, and Phone Number",
  pageHeader = "Customers",
}
type SuperAdminOrganizationsProps = {};

const SuperAdminCustomers: React.FC<SuperAdminOrganizationsProps> = () => {
  /* State */
  const [searchQuery, setSearchQuery] = React.useState("");

  const query = React.useMemo(
    () => ({
      name: searchQuery,
      email: searchQuery,
      phoneNumber: searchQuery,
      any: true,
    }),
    [searchQuery]
  );

  /** Hooks */
  const { data, fetchMore, loading, refetch } = useQuery(QUERY_ALL_CUSTOMERS, {
    variables: {
      pagination: {
        pageSize: 60,
        pageNumber: 1,
      },
      query,
    },
    context: {
      debounceKey: CustomersEnum.queryCustomers,
      debounceTimeout: 250,
    },
  });

  /* Render */
  return (
    <>
      <PageLoader nav sideNav fade={Boolean(data?.allUserProfilesAdmin)} />
      <Page>
        <PageTitle>{CustomersEnum.pageHeader}</PageTitle>
        <SearchContainer>
          <PageSearch
            setSearchQuery={setSearchQuery}
            searchQuery={searchQuery}
            loading={loading}
            placeHolder={CustomersEnum.searchPlaceHolder}
          />
        </SearchContainer>
        <TableContainer>
          <SuperAdminCustomersList
            organizations={data?.allUserProfilesAdmin}
            fetchMore={fetchMore}
            paginationType={PaginationTypes.Organizations}
            isCustomer={true}
            refetch={refetch}
          />
        </TableContainer>
      </Page>
    </>
  );
};

export default SuperAdminCustomers;
